import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { UsersService } from 'src/app/users/users.service';
import { DeviceService } from '../device.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DeviceFactory } from '../device-factory/device-factory';
import { mainDeviceConfig } from '../device-factory/device-config';
import { IotahDevice } from '../device-factory/Iotah-device';
import { TranslateService } from '@ngx-translate/core';
import { SiteDashboardService } from 'src/app/home/site-dashboard/site-dashboard.service';

@Component({
	selector: 'app-device-select-criteria',
	templateUrl: './device-select-criteria.component.html',
	styleUrls: ['./device-select-criteria.component.css']
})
export class DeviceSelectCriteriaComponent implements OnInit, OnChanges {

	@Input() device: any = {};
	@Input() changesStack: any = {};
	@Input() simInfo: any = {};
	@Input() enterprisePermissions: any = {};
	@Input() siteID = 0;
	@Input() customerID = 0;
	@Input() activePage: string;
	@Input() currentSite: any;
	@Input() deviceID: string ='';
	@Input() siteDevices: any = [];
	@Input() deviceLastConnectTime = 0;
	@Input() isStudyDevice: boolean = false;
	@Input() studyId = 0;
	@Input() isPerformanceActive: boolean = false;
	@Input() resetTrigger: number = 0;

	deviceConfig: mainDeviceConfig | null = (new IotahDevice).config;
	deviceType: number = DeviceFactory.types.iotah;

	isTabletOrMobile: boolean = false;
	multiDevices: boolean = false;
	currentUser: any = {};
	currentQueryParams: any = {};
	@Output() onDeviceSelect = new EventEmitter<Object>();
	@Output() changePage = new EventEmitter<{pageName: string}>();
	@Output() onGetSimInfo = new EventEmitter<Object>();
	@Output() selectedPeriod = new EventEmitter<Object>();
	@Output() selectedCriteria = new EventEmitter<Object>();

	@ViewChild('printModal') printModal: any;
	@ViewChild('hiddenPrintBtn') hiddenPrintBtn: ElementRef;

	periods = [
		{ value: 'last_7_days', label: this.translateService.instant('durations.last_7_days') },
		{ value: 'last_14_days', label: this.translateService.instant('durations.last_14_days') },
		{ value: 'last_30_days', label: this.translateService.instant('durations.last_30_days') },
		{ value: 'last_90_days', label: this.translateService.instant('durations.last_90_days') },
		{ value: 'year_to_date', label: this.translateService.instant('durations.year_to_date') },
		{ value: 'last_year', label: this.translateService.instant('durations.last_year') },
		{ value: 'since_installation', label: this.translateService.instant('durations.all_years') },
	];

	printSelectedPeriod = this.periods[0].value;
	waitingForPrint = false;

	daysFilters = [
		{ value: 'allDays', label: this.translateService.instant('g.all_days') },
		{ value: 'workingDays', label: this.translateService.instant('g.working_days') },
	];
	selectedReportDaysFilter = this.daysFilters[0].value;

	constructor(
		private usersService: UsersService,
		private route: ActivatedRoute,
		private router: Router,
		private deviceService: DeviceService,
		public commonService: CommonService,
		private translateService: TranslateService,
		private siteDashboardService: SiteDashboardService,
	) { }

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			this.currentQueryParams = params;
		});

		this.isTabletOrMobile = this.commonService.isTabletOrMobileScreen;
		this.currentUser = this.usersService.getCurrentUser();
		this.route.params.subscribe(params => {
			if(params.deviceId && params.deviceId != '0') {
				let deviceID = params.deviceId || '';
				this.deviceID = deviceID.toLowerCase();
				this.getCachedDevices();
			} else if (this.siteDevices.length > 0 && params.deviceId == '0') {
				this.deviceID =  this.siteDevices[0].mac_address;
				this.deviceChanged();
			}
		});
		const criteria = {period: this.printSelectedPeriod, days: this.selectedReportDaysFilter};
		this.selectedCriteria.emit(criteria);
	}

	ngOnChanges(changes) {
		if(changes.device && this.device && this.device.mac_address) {
			this.deviceType = changes.device.currentValue.config_info.sct_device_type;
			this.deviceConfig = DeviceFactory.createDevice(this.deviceType).config;
		}
		if (changes['resetTrigger']) {
			this.resetFilter();
		}
	}

	getCachedDevices() {
		if(this.deviceID == "0")
			return;

		let multiDevicesIds = this.deviceID.split(',');
		this.multiDevices = (multiDevicesIds.length > 1);
		if(this.multiDevices) {
			this.deviceID = '';
			this.deviceService.getMultiDevicesInfo(multiDevicesIds).subscribe((res: any) => {
				this.deviceLastConnectTime = null;
				this.onDeviceSelect.emit({device: res, multiDevices: this.multiDevices});
			});
		} else {
			this.deviceService.getDeviceInfo(this.deviceID, { get_changes_stack: true, studyId: this.studyId, includeImDevices: true }).subscribe(
				(device: any) => {
					this.deviceSelected(device);
				}
			);
		}
	}

	deviceSelected(device) {
		this.device = device;
		let zoneId = device.config_info.zone_id;
		if(!zoneId)
			zoneId = this.currentSite['zone_id'];

		this.getSimInfo(zoneId);
	}

	get getDeviceLastConnectTime() {
		return moment(this.deviceLastConnectTime * 1000).format('MM/DD/YYYY hh:mm:ss A');
	}

	getSimInfo(zoneId) {
		if (!this.device.config_info.enable_cellular || !(this.usersService.hasAccessPermission(null, 'debug_data') || this.usersService.hasAccessPermission(null, 'noc')))
			return this.onDeviceSelect.emit({device: this.device, zoneId});

		const configInfo = this.device.config_info;
		this.deviceService.getSimInfo(configInfo.cellular_iccid, false, configInfo.mac_address).subscribe((data:any) => {
			if (data.api_status == 2)
				return this.onDeviceSelect.emit({device: this.device, zoneId});

			this.simInfo = data;
			this.onGetSimInfo.emit({simInfo: this.simInfo});
			this.onDeviceSelect.emit({device: this.device, zoneId});
		});
	}

	deviceChanged() {
		let url: any[] = [this.deviceID, this.activePage];
		this.router.navigate(url, { queryParams: this.currentQueryParams, relativeTo: this.route.parent });
	}

	refreshDevice() {
		this.getCachedDevices();
	}

	goToPage(page) {
		this.changePage.emit(page);
	}

	showUserTimeZoneReference() {
				const userTimeZone = moment().utcOffset();
				return moment().utcOffset(userTimeZone).format('UTCZ');
	}

	openPrintModal() {
		this.printModal.show();
	}

	triggerCharglinkPrint() {
		this.siteDashboardService.triggerCharglinkPrint.next();
	}

	onPeriodChanged(value: string) {
		this.printSelectedPeriod = value;
	}

	confirmPrint() {
		this.waitingForPrint = true;
		this.selectedPeriod.emit(this.printSelectedPeriod);
	}

	triggerPrint() {
		if (this.waitingForPrint) {
			this.waitingForPrint = false;
			this.printModal.hide();
			setTimeout(() => {
				this.hiddenPrintBtn.nativeElement.click();
			}, 100);
		}
	}

	confirmPrintTruck() {
		this.waitingForPrint = true;
		this.selectedPeriod.emit(this.printSelectedPeriod);
	}

	onSelectionReportChanged(event) {
		switch (event.filter) {
			case 'period':
				this.printSelectedPeriod = event.value;
				break;
			case 'daysFilter':
				this.selectedReportDaysFilter = event.value;
				break;
			default:
				break;
		}
		const criteria = {period: this.printSelectedPeriod, days: this.selectedReportDaysFilter};
		this.selectedCriteria.emit(criteria);
	}

	resetFilter(){
		this.printSelectedPeriod = this.periods[0].value;
		this.selectedReportDaysFilter = this.daysFilters[0].value;
	}
}
